export default "__VITE_ASSET__D2vUpD3j__"